import React from "react";
import { Paper, Typography, Box, Stack, Link, Button, Divider } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

export default function YourTeamCard() {
  return (
    <Paper
      elevation={1}
      sx={{
        p: 3,                 // p-6
        borderRadius: 3,      // rounded-xl
        border: 1,            // border
        borderColor: "divider",
        bgcolor: "background.paper",
      }}
    >
      {/* Title */}
      <Typography variant="h6" fontWeight={600} color="text.primary" mb={2}>
        Your Relationship Consultant
      </Typography>
      <Divider sx={{ mb: 2 }} />
      {/* Person row */}
      <Box display="flex" alignItems="center" gap={1.5} mb={2}>
        {/* Gradient circle with initials */}
        <Box
          sx={{
            width: 48,  // w-12
            height: 48, // h-12
            borderRadius: "50%",
            background: "#60CFDB", // from-blue-500 to-blue-600
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography sx={{ color: "#fff", fontWeight: 600 }}>B</Typography>
        </Box>

        <Box>
          <Typography fontWeight={500} color="text.primary">
            Bhavya
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Lead Consultant
          </Typography>
        </Box>
      </Box>

      {/* Actions */}
      <Stack spacing={1}>
        <Link
          href="mailto:bhavya@pnptaxworld.com"
          underline="none"
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 1,
            fontSize: 14, // text-sm
            color: "#60CFDB", // text-blue-600
            "&:hover": { color: "primary.dark" }, // hover:text-blue-700
          }}
        >
          <EmailIcon fontSize="small" />
          <span>Send Email</span>
        </Link>

        <Link
          href="tel:+971501915065"
          underline="none"
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 1,
            fontSize: 14,
            color: "#60CFDB",
            "&:hover": { color: "primary.dark" },
          }}
        >
          <PhoneIcon fontSize="small" />
          <span>Call Now</span>
        </Link>

      </Stack>
    </Paper>
  );
}
